<template>
  <splitpanes class="default-theme">

    <pane min-size="15" size="20">
      <div class="card-header" style="width: 100%;border: solid 1px lightgrey">
        <div v-for="item in folderButton" :key="item.id" class="folderButton">
          <FrameButton :key="item.id" :button="item" :parentData="currentFolder"></FrameButton>
        </div>
        <el-icon :size="24" @click="refreshNode(currentFolder.id)" style="margin-top: 5px">
          <ElIconRefresh class="el-icon-refresh"/>
        </el-icon>
      </div>

      <el-tree
          class="mytree"
          ref="tree"
          :data="folderData"
          :props="defaultProps"
          node-key="id"
          :load="loadNode"
          lazy
          @node-click="nodeClickHandle"
          highlight-current
          :expand-on-click-node="false"
          min-height="500px"
          style="height: 100%;overflow: auto"
      >
      </el-tree>
    </pane>

    <pane min-size="50">
      <div class="card-header" style="width: 100%;padding: 3px;border: solid 1px lightgrey">
        <el-row style="width: 100%">
          <el-col :span="20">
            <span width="100%" class="department-name">{{ currentFolder.full_path }}</span>
            <span class="file-count">【{{ schemaList.length }}】</span>
          </el-col>

          <el-col :span="4" align="right" style="display: flex;align-items: center;justify-content: flex-end;">
            <el-popover :width="450" style="border: 1px solid lightgrey">
              <template #reference>
                <el-icon :size="22" style="margin-left: 5px">
                  <ElIconFilter class="el-icon-filter" :color="searchData.hasCondition==true?'blue':'#333333'"/>
                </el-icon>
              </template>

              <template #default>
                <el-form :model="searchData" label-width="90px" style="max-width: 450px">
                  <el-form-item label="含子目录">
                    <el-switch v-model="searchData.searchSub" @change="setHasCondition"/>
                  </el-form-item>
                  <el-form-item label="文件名">
                    <el-input v-model="searchData.fileName" style="width: 240px" @change="setHasCondition"/>
                  </el-form-item>

                  <el-checkbox-group v-model="searchData.fileTypes" @change="setHasCondition">
                    <el-form-item label="文件类型">
                      <el-checkbox value="word" name="type">Word</el-checkbox>
                      <el-checkbox value="excel" name="type">Excel</el-checkbox>
                      <el-checkbox value="ppt" name="type">PPT</el-checkbox>
                      <el-checkbox value="PDF" name="type">PDF</el-checkbox>
                    </el-form-item>
                    <el-form-item label=" " style="margin-top: -20px">
                      <el-checkbox value="image" name="type">Image</el-checkbox>
                      <el-checkbox value="txt" name="type">TXT</el-checkbox>
                      <el-checkbox value="cad" name="type">CAD</el-checkbox>
                      <el-checkbox value="others" name="type">Others</el-checkbox>
                    </el-form-item>
                  </el-checkbox-group>

                  <el-form-item label="文件状态">
                    <el-radio-group v-model="searchData.fileStatus" @change="setHasCondition">
                      <el-radio-button value="release">发布</el-radio-button>
                      <el-radio-button value="edit">编辑中</el-radio-button>
                      <el-radio-button value="review">审核中</el-radio-button>
                      <el-radio-button value="obsolete">废弃</el-radio-button>
                    </el-radio-group>
                  </el-form-item>
                  <el-form-item label="更新日期">
                    <el-radio-group v-model="searchData.updateDateRange" @change="setHasCondition">
                      <el-radio-button value="date_range_0_3">3天内</el-radio-button>
                      <el-radio-button value="date_range_0_7">一周内</el-radio-button>
                      <el-radio-button value="date_range_0_30">一月内</el-radio-button>
                      <el-radio-button value="date_range_31_36500">一月以上</el-radio-button>
                    </el-radio-group>
                  </el-form-item>
                  <el-form-item label=" ">
                    <el-button type="primary" @click="searchSchema">检索</el-button>
                    <el-button type="primary" @click="clearCondition">清除条件</el-button>
                  </el-form-item>
                </el-form>
              </template>
            </el-popover>

            <el-popover :width="260" style="border: 1px solid lightgrey">
              <template #reference>
                <el-icon :size="22" style="margin-left: 5px">
                  <ElIconSort class="el-icon-sort" :color="(searchData.searchOrder != 'name')?'blue':'#333333'"/>
                </el-icon>
              </template>
              <template #default>
                <el-form :model="searchData" label-width="90" style="max-width: 300px">
                  <el-radio-group v-model="searchData.searchOrder" @change="searchSchema">
                    <el-form-item label="文件名称">
                      <el-radio-button value="name">升序</el-radio-button>
                      <el-radio-button value="name desc">降序</el-radio-button>
                    </el-form-item>
                    <el-form-item label="创建时间">
                      <el-radio-button value="create_time">升序</el-radio-button>
                      <el-radio-button value="create_time desc">降序</el-radio-button>
                    </el-form-item>
                    <el-form-item label="更新时间">
                      <el-radio-button value="update_time">升序</el-radio-button>
                      <el-radio-button value="update_time desc">降序</el-radio-button>
                    </el-form-item>
                  </el-radio-group>
                </el-form>
              </template>
            </el-popover>

            <el-popover :width="310" style="border: 1px solid lightgrey">
              <template #reference>
                <el-icon :size="22" style="margin-left: 5px">
                  <ElIconCirclePlus class="el-icon-circle-plus" color="green"/>
                </el-icon>
              </template>
              <template #default>
                <!-- 循环schemaItems，添加多个按钮，flex 布局 -->
                <div style="display: flex; flex-direction: row; justify-content: flex-start; align-items: center; flex-wrap: wrap;">
                  <el-button style="display: inline-flex; width: 120px; margin: 5px 10px 5px 10px;" v-for="item in schemaItems" @click="addSchema(item)">{{ item.name }}</el-button>
                </div>
              </template>
            </el-popover>

          </el-col>
        </el-row>
      </div>

      <div class="doc-box" style="height: 100%;background-color: white; overflow-y: auto">
        <el-table :data="schemaList" stripe style="width: 100%">
          <el-table-column prop="type" label="类型" width="90"/>
          <el-table-column prop="code" label="code" width="180"/>
          <el-table-column prop="description" label="描述" min-width="150"/>
          <el-table-column prop="locked_name" label="锁定" width="80"/>
          <el-table-column prop="status" label="状态" width="80"/>
          <el-table-column prop="create_user_name" label="创建人" width="120"/>
          <el-table-column prop="create_time" label="创建时间" width="180"/>
          <el-table-column prop="update_user_name" label="更新人" width="120"/>
          <el-table-column prop="update_time" label="更新时间" width="180"/>
          <el-table-column prop="content_length" label="内容长度" width="100"/>
          <el-table-column label="编辑" width="80" fixed="right">
            <template #default="scope">
              <el-button size="small" @click="editSchema(scope.$index, scope.row)">
                编辑
              </el-button>
            </template>
          </el-table-column>
        </el-table>

        <el-pagination style="margin-left: auto"
                       :current-page="1"
                       :page-size="20"
                       :page-sizes="[20, 15, 30, 50]"
                       :size="size"
                       background
                       layout="sizes, prev, pager, next"
                       :total="1000"
                       @size-change="handleSizeChange"
                       @current-change="handleCurrentChange"
        />

      </div>

    </pane>

  </splitpanes>
</template>

<script>

import {Pane, Splitpanes} from 'splitpanes'
import 'splitpanes/dist/splitpanes.css'

export default {
  name: "SchemaBuilder",
  components: {Splitpanes, Pane},
  data() {
    return {
      folderButton: [
        {
          "component": "button",
          "type": "text",
          "icon": "el-icon-folder-add",
          "style": "font-size: 24px",
          "icon_only": true,
          "click": "jsOpenDialog",
          "click_success": ["jsRefreshForm"],
          "window": {"component": "frame/FrameForm", "type": "sys_schema_dir_add", "title": "添加子目录", "width": 500, "height": 300}
        },
        {
          "component": "button",
          "type": "text",
          "icon": "el-icon-edit",
          "style": "font-size: 24px",
          "icon_only": true,
          "click": "jsOpenDialog",
          "click_success": ["jsRefreshForm"],
          "window": {"component": "frame/FrameForm", "type": "sys_schema_dir_edit", "title": "修改目录", "width": 500, "height": 300}
        },
        {
          "component": "button",
          "type": "text",
          "icon": "el-icon-TopRight",
          "style": "font-size: 24px",
          "icon_only": true,
          "click": "jsOpenDialog",
          "click_success": ["jsRefreshForm"],
          "window": {"component": "frame/FrameForm", "type": "sys_schema_dir_move", "title": "移动目录和对象", "width": 600, "height": 300}
        },
        {
          "component": "button",
          "type": "text",
          "icon": "el-icon-delete",
          "icon_only": true,
          "style": "font-size: 24px",
          "click": "jsOpenDialog",
          "click_success": ["jsRefreshForm"],
          "window": {"component": "frame/FrameForm", "type": "sys_schema_dir_del", "title": "删除目录", "width": 600, "height": 300}
        },
        {
          "component": "button",
          "text": true,
          "circle": true,
          "icon_only": true,
          "icon": "el-icon-Grid",
          "style": "font-size: 24px",
          "click": "jsOpenDialog",
          "window": {"component": "frame/FrameForm", "type": "sys_schema_dir_import", "title": "导入目录", "width": 500, "height": 300}
        }
      ],
      orderItems: [{"name": "对象ID升序", "value": "name_asc"}, {"name": "对象ID降序", "value": "name_desc"}, {"name": "创建时间升序", "value": "create_time"}, {
        "name": "创建时间降序",
        "value": "-create_time"
      }, {"name": "修改时间升序", "value": "update_time"}, {"name": "修改时间降序", "value": "-update_time"}],
      schemaItems: [
        {"name": "桌面应用", "value": "app"},
        {"name": "菜单", "value": "menu"},
        {"name": "表单", "value": "form"},
        {"name": "表格", "value": "table"},
        {"name": "查询", "value": "query"},
        {"name": "TAB容器", "value": "tab"},
        {"name": "数据模型", "value": "model"},
        {"name": "导入定义", "value": "import"},
        {"name": "提示徽章", "value": "badge"},
        {"name": "文件仓库", "value": "store"},
        {"name": "定时任务", "value": "task"},
        {"name": "工作流", "value": "prc_template"},
        {"name": "字典", "value": "dict"},
        {"name": "正则表达式", "value": "regex"},
        {"name": "Java Bean", "value": "java_bean"},
        {"name": "网页窗口", "value": "vue_window"}
      ],
      addData: {parentId: '', name: ''},
      searchData: {hasCondition: false, fileName: '', searchSub: false, searchOrder: 'name', fileTypes: [], fileStatus: '', updateDateRange: ''},
      folderData: [],
      currentFolder: {},
      editData: {},
      defaultProps: {
        children: 'children',
        label: 'name',
        isLeaf: 'leaf',
      },
      schemaList: [],
    }
  },
  provide() {
    return {
      $fn: {
        reloadTreeData: () => {
          // 刷新当前节点
          this.refreshNode(this.currentFolder.id);
        },
        reloadParentNode: () => {
          //刷新父节点
          console.log("reloadParentNode,parent_id:" + this.currentFolder.parent_id)
          this.refreshNode(this.currentFolder.parent_id);
        },
        searchSchema: () => {
          //查询
          console.log("searchSchema,dir_id:" + this.currentFolder.id)
          this.searchSchema();
        }
      }
    }
  },
  methods: {
    refreshNode(nodeId) {
      if (nodeId && nodeId.length > 0) {
        this.$refs.tree.store.nodesMap[this.currentFolder.id].loaded = false;
        this.$refs.tree.store.nodesMap[this.currentFolder.id].loadData();
      } else {
        this.loadDirTree()
      }
    },
    //--勾选--
    nodeClickHandle(currentRow) {
      this.currentFolder = currentRow
      this.searchSchema();
    },
    async loadDirTree() {
      let data = await this.$http('sysSchemaDirService.getChildren', {parent_id: ''})
      this.folderData = data;
    },
    async loadNode(node, resolve) {
      console.log("node.id=" + node.data.id);
      let data = await this.$http('sysSchemaDirService.getChildren', {parent_id: node.data.id})
      resolve(data)
    },
    async searchSchema() {
      this.searchData.dirId = this.currentFolder.id
      this.schemaList = await this.$http('sysSchemaService.searchSchema', this.searchData);

      if (this.schemaList.length >= 500) {
        this.$message.warning("检索结果达到上限【500】，建议进行更精确的检索");
      }
    },
    clearCondition() {
      this.searchData.hasCondition = false;
      this.searchData.searchSub = false;
      this.searchData.fileName = '';
      this.searchData.searchOrder = '';
      this.searchData.fileStatus = '';
      this.searchData.updateDateRange = '';
      this.searchData.fileTypes = []
      this.searchSchema();
    },
    setHasCondition() {
      if (this.searchData.searchSub == true) {
        this.searchData.hasCondition = true;
        return
      }

      if (this.searchData.fileName.length > 0) {
        this.searchData.hasCondition = true;
        return
      }

      if (this.searchData.fileStatus.length > 0) {
        this.searchData.hasCondition = true;
        return
      }

      if (this.searchData.fileTypes.length > 0) {
        this.searchData.hasCondition = true;
        return
      }

      if (this.searchData.updateDateRange.length > 0) {
        this.searchData.hasCondition = true;
        return
      }

      this.searchData.hasCondition = false;
      return
    },
    addSchema(item) {
      let editorMode = "json";
      if(item.value == 'java_bean'){
        editorMode = "java";
      }

      let windowObj = {}
      windowObj.icon = "system/bug";
      windowObj.component = "FrameJsonAi1";
      if(item.value == 'java_bean'){
        windowObj.component = "FrameJavaEditor";
      }

      windowObj.name = "新增" + item.name + "配置";
      if(item.value == 'java_bean'){
        windowObj.name = "Java编辑器";
      }
      windowObj.parentData = {
        type: item.value,
        dir_id: this.currentFolder.id,
        editorMode: editorMode,
        edit_mode:false
      };
      windowObj.max = true
      this.$store.dispatch('core/openWindow', windowObj)

    },
    editSchema(index, item) {
      let windowObj = {}
      windowObj.icon = "system/bug";
      windowObj.component = "FrameJsonAi1";
      windowObj.name = "编辑[" + item.code + "]";
      windowObj.parentData = {
        id: item.id,
        code: item.code,
        type: item.type,
        dir_id: this.currentFolder.id,
        edit_mode:true
      };
      windowObj.max = true
      this.$store.dispatch('core/openWindow', windowObj)

    }
  },
  created() {

  }
}
</script>


<style lang="less" scoped>
@import '@/global.less';

.myContainer {
  padding: 5px;
}

.folderButton {
  display: inline-flex;
}

.card-header {
  display: inline-flex;
  height: 36px;
}

.department-name {
  font-size: @fontSizeX;
}


.activeButton {
  background-color: #409EFF;
  color: #FFFFFF
}

.scroller::-webkit-scrollbar {
  width: 3px;
}

.scroller::-webkit-scrollbar-track {
  background-color: transparent;
}

.scroller::-webkit-scrollbar-thumb {
  background-color: #C1C1C1;
}

.doc-box {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  align-content: flex-start;
  min-height: 600px;
}

.doc-card {
  width: 150px;
  height: 210px;
  margin: 10px;
  border: 1px solid gainsboro;
  border-radius: 10px;
}

.doc-card:hover {
  background-color: #E5F3FF;
}

.file-count {
  color: #409EFF;
  font-size: large;
  margin-left: 5px;
}

.pdf {
  background-image: url("../../../../public/icon/filetype/pdf.png");
}

.excel {
  background-image: url("../../../../public/icon/filetype/excel.png");
}

.word {
  background-image: url("../../../../public/icon/filetype/word.png");
}

.ppt {
  background-image: url("../../../../public/icon/filetype/ppt.png");
}

.png {
  background-image: url("../../../../public/icon/filetype/jpg.png");
}

.file {
  background-image: url("../../../../public/icon/filetype/file.png");
}

.icon {
  width: 100px;
  height: 100px;
  background-size: 100px 100px;
  margin-left: 25px;
}

.doc-name {
  font-size: 16px;
  width: 100%;
  height: 33px;
  margin-top: 10px;
  margin-bottom: 10px;
  //word-wrap: normal;
  word-wrap: break-word;
  word-break: break-all;
  overflow: hidden;
  line-height: 16px;
  padding-left: 10px;
  text-align: center;
}

.doc-version {
  margin-left: 10px;
  font-size: 20px;
  width: 100%;
  height: 25px;
  line-height: 25px;
  text-align: center;
}

.doc-author {
  font-size: 16px;
  width: 100%;
  height: 25px;
  line-height: 25px;
  text-align: center;
}

.doc-time {
  font-size: 14px;
  width: 100%;
  height: 20px;
  line-height: 20px;
  text-align: center;
}

.doc-status {
  font-size: 12px;
  width: 100%;
}

.doc-menu {
  font-size: 14px;
  margin: 5px 0 0 5px;
}

.departmentBody {
  border: #ececec solid 1px;
  font-weight: normal;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  height: 100%;
  width: 100%;
  padding: 0 1px 2px;
}

.departmentLeft {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  width: 300px;
  box-sizing: content-box;
}

.departmentRight {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  overflow: auto;
  width: 100%;
  min-width: 550px;
}

.LeftBody {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  width: 300px;
  padding-top: 10px;
  overflow-y: auto;
}

.flexRow {
  display: flex;
  flex-direction: row;
  width: 100%;
}

.userRights {
  display: flex;
  flex-direction: column;
  height: 100%;
  margin: 5px 5px 0 5px;
}

.departmentUserList {
  padding: 0 20px 10px;
  display: flex;
  flex-direction: column;
}

.departmentTitle {
  height: 45px !important;
  line-height: 40px;
  font-size: @fontSizeSS;
}

.departmentName {
  white-space: nowrap;
  min-width: 120px;
  margin-right: 30px;
  padding-right: 20px;
  font-size: @fontSizeS;
}

.titleFlex {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
}

.departmentEdit {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  margin: 10px 0;
}

.departmentTable {
  border: none;
  width: 100%;
}

.flexRow > .el-menu-item {
  height: 50px;
  line-height: 50px;
}

.buttonGroup {
  margin-left: auto;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
}

.addButton {
  margin-left: 5px !important;
  padding: 9px;
}

.addDepartment {
  width: 140px;
  margin-right: 5px;
}

.LeftBody ::v-deep(.el-tree-node__expand-icon) {
  width: 15px;
}

.buttonGroup ::v-deep(.el-icon-key) {
  transform: rotate(180deg);
}

.editButton {
  color: lightgrey;
  min-height: 30px;
  padding: 0;
}

.editButton:hover {
  color: #00afff;
}

.mytree {
  margin-left: -15px;

  :deep(.el-tree-node__content) {
    padding: 0 !important;
  }

  :deep(.el-tree-node) {
    position: relative;
    padding-left: 16px;
  }

  :deep(.el-tree-node__children) {
    padding-left: 16px;
  }

  // 竖线
  :deep(.el-tree-node::before) {
    content: "";
    height: 100%;
    width: 1px;
    position: absolute;
    left: -3px;
    top: -26px;
    border-width: 1px;
    border-left: 1px dashed #b8b9bb;
  }

  :deep(.el-tree-node:last-child::before) {
    height: 38px;
  }

  // 横线
  :deep(.el-tree-node::after) {
    content: "";
    width: 24px;
    height: 20px;
    position: absolute;
    left: -3px;
    top: 12px;
    border-width: 1px;
    border-top: 1px dashed #b8b9bb;
  }

  :deep(& > .el-tree-node::after) {
    border-top: none;
  }

  :deep(& > .el-tree-node::before) {
    border-left: none;
  }

  :deep(.el-tree-node__expand-icon) {
    font-size: 16px;
  }

  :deep(.is-leaf) {
    display: none; // 也可以去掉
  }
}
</style>
